import { Injectable, EventEmitter } from '@angular/core'
import PouchDB from 'pouchdb';

@Injectable({
    providedIn: 'root'
})
export class CouchCodsPRDSService {

    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();
    private idkatios;
    private aplSyncCouchAuto = true;

    constructor() {
        if (!this.isInstantiated) {
            this.CrearPouchSincronizacion()
        }
    }

    getFlagSyncCouch() {
        var sSUbicacion = sessionStorage.getItem("SUbicacion");
        var oSUbicacion;
        let flag: boolean = true;
        let config;

        if (sSUbicacion) {
            oSUbicacion = JSON.parse(sSUbicacion);
            if (oSUbicacion.M3HUBS && oSUbicacion.M3HUBS[0] && oSUbicacion.M3HUBS[0].Configuracion) {
                config = JSON.parse(oSUbicacion.M3HUBS[0].Configuracion);

                if (config.SyncCouchAuto != null && config.SyncCouchAuto != undefined) {
                    flag = config.SyncCouchAuto;
                }
            }
        }
        return flag;
    }

    public CrearPouchSincronizacion() {

        this.idkatios = this.GetIdKatiosLVL1FromSession();
        this.database = new PouchDB("codsprd_" + this.idkatios, { auto_compaction: true });
        console.debug("adapter")
        console.debug(this.database.adapter);

        this.sync(this.GetServer() + "codsprd_" + this.idkatios.toLowerCase());
        this.isInstantiated = true;
        console.log("********************************** INSTANCE PRODUCTOS *****************************************")

    }

    syncCouch() {
        if (!this.idkatios) {
            this.CrearPouchSincronizacion();
        }
        else {
            this.sync(this.GetServer() + "codsprd_" + this.idkatios.toLowerCase());
        }
    }

    public GetServer(): string {
        //var json = require('../../../assets/Config/config.json');
        var json = require('G:/Desarrollo/BD/WE8/config.json');
        return json.CouchDBM3;
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    public sync(remote: string) {
        this.aplSyncCouchAuto = this.getFlagSyncCouch();
        let remoteDatabase = new PouchDB(remote, { auto_compaction: true });

        this.database.replicate.from(remoteDatabase, {
            live: this.aplSyncCouchAuto,
            retry: true
        }).on('complete', change => {
            console.log("********************************** COMPLETO CAMBIO CODS PRODUCTOS *****************************************")
        }).on('change', change => {
            this.listener.emit(change);
            console.log("********************************** CHANGE CAMBIO CODS PRODUCTOS *****************************************")
        }).on('error', function (err) {
            console.log("Error")
            // boo, something went wrong!
        });
    }

    public get(id: string) {
        return this.database.get(id);
    }

    public fetch() {
        return this.database.allDocs({ include_docs: true });
    }

    public getEncabezado() {
        return this.database.allDocs({ include_docs: false });
    }

    public getChangeListener() {
        return this.listener;
    }



    public async Destroy() {
        var respuesta;
        respuesta = await this.database.destroy()
        return respuesta
    }
}